// extracted by mini-css-extract-plugin
export default {"input":"oryx-textarea_input__KVSOR","input-invalid":"oryx-textarea_input-invalid__5UPzY"};